<template>
    <div class="assets-box">
        <div v-for="(array, index) in amountList" :key="index">
            <div class="assets-type">
                <div class="title-line"></div>
                <span class="title-content">{{ amountTypes[index] }}</span>
            </div>
            <div class="assets-info">
                <div v-for="(item, idx) in array" :key="idx" class="assets-item">
                    <div class="amount-type">
                        {{ item.text }}
                        <span v-if="idx > 0" class="time-item">
                            {{ fmtDateDDMM(allAssets.profitdate) }}
                        </span>
                    </div>
                    <div class="assets-text" :class="$util.colorClass($util.fmtNum(item.val))">
                        {{ $util.fmtNum(item.val) }}
                    </div>
                    <div v-if="idx == 0 && item.process > 0" class="assets-process">
                        <span class="process-text">
                            在途资产(元)：{{ $util.fmtNum(item.process) }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="assets-type">
            <div class="title-line"></div>
            <span class="title-content">我的持仓</span>
        </div>
        <el-row v-if="assets.length <= 0 && hasLoad" class="no-funds">
            <el-col :span="12" :offset="8">
                <span class="no-funds-img" />
                <div class="no-funds-box">
                    <p>暂无数据</p>
                </div>
            </el-col>
        </el-row>
        <el-table
            v-else-if="hasLoad"
            :data="assets"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: '#F9F9F9' }"
        >
            <el-table-column label="基金名称(代码)" width="280" class-name="fund-offset">
                <template slot-scope="scope">
                    <div class="fund-name" v-on:click.stop="gotoDetail(scope.row)">
                        {{ scope.row.fundshortname || scope.row.fundname }}({{
                            scope.row.fundcode
                        }})
                    </div>
                    <p v-if="scope.row.processmarketvalue > 0" class="subscribe">
                        申购中：{{ $util.fmtNum(scope.row.processmarketvalue) }}元
                    </p>
                    <p
                        v-if="scope.row.processredemption && scope.row.processredemption > 0"
                        class="sell"
                    >
                        赎回中：{{ $util.fmtNum(scope.row.processredemption) }}份
                    </p>
                </template>
            </el-table-column>
            <el-table-column label="总资产(元)" align="center" prop="marketvalue" sortable>
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.marketvalue) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="上一个交易日收益(元)"
                align="center"
                min-width="120"
                prop="lastprofit"
                sortable
            >
                <template slot-scope="scope">
                    <span :class="$util.colorClass($util.fmtNum(scope.row.lastprofit))">
                        {{ $util.fmtNum(scope.row.lastprofit) }}
                    </span>
                    <br />
                    <span class="time-item">{{ fmtDateDDMM(scope.row.profitdate) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="持有收益(元)" align="center" prop="currentprofit" sortable>
                <template slot-scope="scope">
                    <span :class="$util.colorClass($util.fmtNum(scope.row.currentprofit))">
                        {{ $util.fmtNum(scope.row.currentprofit) }}
                    </span>
                    <br />
                    <span class="time-item">{{ fmtDateDDMM(scope.row.profitdate) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="持有收益率" align="center" prop="currentprofitrate" sortable>
                <template slot-scope="scope">
                    <span :class="$util.colorClass($util.fmtNum(scope.row.currentprofitrate))">
                        {{ formatterRate(scope.row.currentprofitrate) }}
                    </span>
                    <br />
                    <span class="time-item">{{ fmtDateDDMM(scope.row.profitdate) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="累计收益(元)" align="center" prop="totalprofit" sortable>
                <template slot-scope="scope">
                    <span :class="$util.colorClass($util.fmtNum(scope.row.totalprofit))">
                        {{ $util.fmtNum(scope.row.totalprofit) }}
                    </span>
                    <br />
                    <span class="time-item">{{ fmtDateDDMM(scope.row.profitdate) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="100">
                <template slot-scope="scope">
                    <div class="btns">
                        <el-button
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="showDetail(scope.row)"
                        >
                            详情
                        </el-button>
                        <div class="line"></div>
                        <el-tooltip
                            class="item"
                            effect="info"
                            :content="scope.row.isSell || '请下载理财客APP赎回该产品'"
                            placement="top"
                        >
                            <el-button type="text" disabled size="small">赎回</el-button>
                        </el-tooltip>
                        <!--暂时屏蔽 和讯不支持-->
                        <!--                        <div class="line"></div>
                        <el-tooltip
                            v-if="scope.row.isChange"
                            class="item"
                            effect="info"
                            :content="scope.row.isChange + '，不能转换'"
                            placement="top"
                        >
                            <el-button disabled type="text" size="small">转换</el-button>
                        </el-tooltip>
                        <el-button
                            v-else
                            type="text"
                            plain
                            size="small"
                            v-on:click.stop="showBuyModal(scope.row)"
                        >
                            转换
                        </el-button>-->
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > 0" class="page-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="newAssets"
            />
        </el-row>
        <qr-code
            :fundcode="selectFundCode"
            :is-public="selectFundClass == '0'"
            :dialog-visible="buyDialogVisible"
            v-on:dialog-close="buyDialogVisible = false"
        ></qr-code>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";
import qrCode from "@/components/fund/qrCodeGuide";
import format from "date-fns/format";
export default {
    name: "MyAssets",
    components: { qrCode },
    mixins: [mixin],
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            allAssets: {}, // 资产汇总信息
            assets: [], // 资产列表
            queryFind: null, // 定时器
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            amountList: [], // 资产总额列表
            amountTypes: ["总资产", "公募基金", "高端理财"], // 资产总额类型
            curPage: 1, // 当前页
            hasLoad: false, // 是否已经查询数据
            buyDialogVisible: false, // 是否显示购买弹窗
            selectFundClass: "", // 所选基金类型 公募、私募
            selectFundCode: "" // 所选基金代码
        };
    },
    watch: {
        allPage() {
            this.curPage = 1;
        },
        "$store.state.user.info": {
            handler() {
                this.doAction();
            },
            deep: true
        }
    },
    mounted() {
        this.conf = this.$util.getConfig().const;
        this.doAction();
    },
    methods: {
        // 跳转到基金详情
        gotoDetail(val) {
            if (val.producttype) {
                this.$util.toFundDetail(val.fundcode, val.producttype === "0");
                return;
            }
            fundApi
                .qryFundClass({
                    fundcode: val.fundcode,
                    pagesize: "1",
                    pagenum: "1",
                    fundclass: "*"
                })
                .then((res) => {
                    if (res.data && res.data.list && res.data.list.length) {
                        const fund = res.data.list[0];
                        const isPublic = fund.fundclass == "0";
                        this.$util.toFundDetail(val.fundcode, isPublic);
                    }
                });
        },
        // 获取新一页数据
        newAssets(val) {
            this.pageoffset = val;
            this.doAction();
        },
        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getAssets(val, cb);
            }, 500);
        },
        // 获取资产信息
        async getAssets(val, cb) {
            if (
                !this.$cache.getBinded() ||
                !(this.$store.state.user.info && this.$store.state.user.info.custname)
            ) {
                return;
            }
            const res = await fundApi.getAssetsList({
                producttype: "@",
                pageSize: cb ? 20 : this.pagecount,
                pageNum: val ? 1 : this.pageoffset
            });
            this.hasLoad = true;
            if (res.data) {
                this.allAssets = res.data.first ? res.data.first : {};
                this.assignAmountList();
                const array = res.data.returnList ? res.data.returnList : [];
                array.forEach((fund, index) => {
                    fund.isBuy = this.$util.checkBuy(fund.status);
                    fund.isSell = this.$util.checkSell(fund);
                    fund.isChange = this.$util.checkChange(fund);
                    fund.isCurrency = this.$util.checkGeneral(fund);
                });
                if (!val) {
                    if (this.pageoffset == 1) {
                        this.curPage = 1;
                    }
                    this.assets = array;
                }
                if (!cb) {
                    this.allPage = res.data.total ? res.data.total.toString() : "0";
                } else {
                    cb.call(this, array);
                }
            }
        },
        // 赋值资产金额列表
        assignAmountList() {
            const array1 = [
                {
                    text: "总资产(元)",
                    val:
                        Number(this.allAssets.totalasset) +
                        Number(this.allAssets.totalincome || "0"),
                    process: this.allAssets.processasset
                },
                {
                    text: "最新日收益(元)",
                    val: this.allAssets.lastprofit
                },
                {
                    text: "累计收益(元)",
                    val: this.allAssets.totalprofit
                }
            ];
            const array2 = [
                {
                    text: "总资产(元)",
                    val:
                        Number(this.allAssets.generalasset) +
                        Number(this.allAssets.generaltotalincome || "0"),
                    process: (
                        this.allAssets.processasset - this.allAssets.privateprocessasset
                    ).toString()
                },
                {
                    text: "最新日收益(元)",
                    val: this.allAssets.generallastprofit
                },
                {
                    text: "累计收益(元)",
                    val: this.allAssets.generaltotalprofit
                }
            ];
            const array3 = [
                {
                    text: "总资产(元)",
                    val:
                        Number(this.allAssets.privateasset) +
                        Number(this.allAssets.privatetotalincome || "0"),
                    process: this.allAssets.privateprocessasset
                },
                {
                    text: "最新日收益(元)",
                    val: this.allAssets.privatelastprofit
                },
                {
                    text: "累计收益(元)",
                    val: this.allAssets.privatetotalprofit
                }
            ];
            this.amountList = [array1, array2, array3];
        },
        // 格式化涨跌幅数据
        formatterRate(rate) {
            if (rate || rate === 0) {
                const prefix = Number(rate) > 0 ? "+" : "";
                return prefix + this.$util.fmtNum(rate) + "%";
            }
            return "--";
        },
        showBuyModal(val) {
            this.selectFundCode = val.fundcode;
            if (val.producttype) {
                this.selectFundClass = val.producttype;
                this.buyDialogVisible = true;
            } else {
                fundApi
                    .qryFundClass({
                        fundcode: this.selectFundCode,
                        pagesize: "1",
                        pagenum: "1",
                        fundclass: "*"
                    })
                    .then((res) => {
                        if (res.data && res.data.list && res.data.list.length) {
                            const fund = res.data.list[0];
                            this.selectFundClass = fund.fundclass;
                            this.buyDialogVisible = true;
                        }
                    });
            }
        },
        // 跳转到详情
        showDetail(item) {
            sessionStorage.setItem(
                "_currentAsset",
                JSON.stringify({ ...item, latestbulletindate: this.allAssets.latestbulletindate })
            );
            this.$router.push("/assetsDetail");
        },
        // 点击申购或赎回按钮
        callbackFn(way, fund) {
            let moduleId = "";
            let flag = "0";
            if (way == "24") {
                moduleId = way;
            } else {
                if (fund.status == "1") {
                    moduleId = "20";
                } else {
                    moduleId = "22";
                }
            }
            if (moduleId == "20" || moduleId == "22" || moduleId == "36" || moduleId == "29") {
                flag = "0";
            } else {
                flag = "1";
            }
            // 申购 22 认购 20  转换36  赎回24  预约赎回25
            const _this = this;
            _this.$util.checkGtOcrModule(moduleId, flag, (res) => {
                _this.fundCon(way, fund);
            });
        },
        // 进一步操作
        fundCon(way, fund) {
            const _this = this;
            if (way === "24") {
                const _fund = _this.$util.dataTaacFilter(fund);
                const _x = Object.assign({}, _fund, { way: way });
                sessionStorage.setItem("sellfund", JSON.stringify(_x));
                this.$router.push({ name: "sellfund", query: { fundcode: fund.fundcode } });
            } else {
                let _url = "";
                // 购买
                if (way === "20,22") {
                    // 普通购买
                    fund.proto = "buy";
                    this.$util.fundRiskCheck(this, fund, (res) => {
                        if (res) {
                            _this.$util.getSdxProtocol(res, (data) => {
                                if (data) {
                                    const _x = Object.assign({}, data, { way: way });
                                    _url = "buyfund";
                                    sessionStorage.setItem(_url, JSON.stringify(_x));
                                    _this.$router.push({
                                        name: _url,
                                        query: { fundcode: _x.fundcode }
                                    });
                                }
                            });
                        }
                    });
                }
            }
        },
        fmtDateDDMM(profitdate) {
            return profitdate ? format(profitdate, "MM-DD") : "--";
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/varibles";
.assets-box {
    padding: 20px;
    .assets-type {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
    }
}
.assets-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 24px;

    .assets-item {
        display: flex;
        flex-direction: column;
        width: 360px;
        height: 122px;
        border-radius: 6px;
        background: #ffffff;
        box-sizing: border-box;
        border: 1px solid #d9d9d9;
        justify-content: center;
        padding-left: 32px;

        .amount-type {
            font-size: 14px;
            color: #333333;
            margin-bottom: 12px;
        }
        .assets-text {
            font-size: 32px;
            line-height: 28px;
            font-weight: 500;
            color: #000000;
            margin-bottom: 2px;
        }
        .assets-process {
            display: flex;
            .process-text {
                box-sizing: border-box;
                background: url("../../assets/img/process-bg.png");
                background-size: cover;
                height: 34px;
                padding: 10px 8px 8px;
                font-size: 14px;
                font-weight: normal;
                color: #e60012;
            }
        }
        .add {
            color: $risk5;
        }
        .reduce {
            color: $risk1;
        }
    }
}
.btns {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 11px;
}
.line {
    background: #e8e8e8;
    width: 1px;
    height: 12px;
}
.fund-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}
.el-table td.el-table__cell div {
    color: #333333;
}
.el-table td.el-table__cell span {
    color: #333333;
    &.add {
        color: $risk5;
    }
    &.reduce {
        color: $risk1;
    }
    &.time-item {
        color: $text-color7;
    }
}
.el-table td.el-table__cell {
    .subscribe {
        font-size: 12px;
        color: $risk5;
    }
    .sell {
        font-size: 12px;
        color: $text-color4;
    }
}

.el-table {
    border: 1px solid #f1f1f1;
}
.el-table--fit {
    margin-bottom: 20px;
}
.el-button.is-plain:hover,
.el-button.is-plain:focus,
.el-button.is-disabled.is-plain {
    background-color: transparent;
    border-color: transparent;
}
.el-button--text {
    font-size: 14px;
    font-weight: normal;
    color: #e60012;
}
.el-button--text.is-disabled {
    color: #cccccc;
}
.page-box {
    padding: 0;
}
.el-pagination {
    margin-bottom: 0;
}
.time-item {
    font-size: 12px;
    color: $text-color7;
}
</style>
